<template>
  <b-form-group>
    <label class="d-block">
      <b-row>
        <b-col>{{ trans('blind_carbon_copy') }}</b-col>
        <b-col class="text-right">
          <b-button variant="link" class="p-0" :href="`/organization/${organization.id}/user`" target="_blank">
            {{ trans('manage_users') }}
            <i class="fa fa-fw fa-external-link-alt"></i>
          </b-button>
        </b-col>
      </b-row>
    </label>
    <users-select
      :organization="organization"
      v-model="cc_user_ids"
      :confirmed="null"
      :show-email="showEmail"
      :show-mobile="showMobile"
      show-add-guest
      :disabled="disabled"
    ></users-select>
  </b-form-group>
</template>

<script>
  import UsersSelect from './../orguser/UsersSelect'

  export default {
    props: {
      organization: Object,
      value: Array,
      showEmail: {
        type: Boolean,
        default: false,
      },
      showMobile: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      UsersSelect,
    },
    data() {
      return {
        trans: trans,
        cc_user_ids: this.value,
      }
    },
    watch: {
      cc_user_ids() {
        this.$emit('input', this.cc_user_ids)
      },
    },
  }
</script>